<template>
    <div class="dollar-input">
        <label>$</label>
        <div class="dollar-input-padding">
            <input
                ref="input"
                v-bind:value="value"
                v-bind:disabled="disabled"
                v-on:input="updateValue($event.target.value)"
                v-on:focus="selectAll"
                v-on:blur="formatValue" />
        </div>
    </div>
</template>

<style lang="scss">
    .dollar-input {
        position: relative;
		font-size: 0.8em;
        border: 1px solid #ccc;
        padding: 2px;
        background: #fff;
        label {
            font-size: 0.8em;
            font-weight: 300;
            display: block;
            position: absolute;
            top: 0.4em;
            left: 0.4em;
            opacity: 1;
            color: #333333;
            max-width: none;
            margin: 0;
        }
        .dollar-input-padding {
            padding-left: 1em;
        }
        input {
            border: 0;
            padding: 0;
            width: 100%;
            background: #fff;
        }
    }
</style>

<script>
    export default {
        props: {
			value:{
				type: [String,Number],
				default: ''
			},
			includeCents: {
				type: Boolean,
				default: true,
            },
			disabled: {
				type: Boolean,
				default: false,
            },            
		},

        mounted() {
            this.formatValue();
        },

        methods: {
            updateValue(value) {
                var parseValue = (value + '').replace(/[^0-9+\-Ee\.]/g, '');
                this.$refs.input.value = parseValue;
                this.$emit('input', parseValue);
            },
            formatValue() {
				let formattedValue = Number(this.value).toLocaleString("en-US", {style: "currency", currency: "USD"}).substring(1);
				if (!this.includeCents) {
					formattedValue = formattedValue.split('.')[0];
				}
				this.$refs.input.value = formattedValue;
				this.$emit('input', (formattedValue+'').replace(/[^0-9+\-Ee\.]/g, ''))
            },
            selectAll(event) {
                // Workaround for Safari bug
                // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
                setTimeout(function () {
                    event.target.select()
                }, 0)
            }
        }
    }
</script>